
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1002.193 1124.29"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 15","d":"M991.379 834.025a20.694 20.694 0 003.947-2.92c.27-.27.595-.541.865-.865a21.713 21.713 0 006-14.924v-523a21.64 21.64 0 00-11.031-18.872L508.775 2.704a26.261 26.261 0 00-1.244-.649h-.162a20.6 20.6 0 00-3.461-1.3h-.162a22.529 22.529 0 00-5.732-.757h-.108a22.054 22.054 0 00-6 .865h-.271a20.6 20.6 0 00-3.569 1.46h-.108c-.216.108-.379.216-.595.324L11.14 267.23A21.651 21.651 0 000 286.16v529.156a19.951 19.951 0 00.649 5.137v.162a21.416 21.416 0 001.568 4.272v.108a21.533 21.533 0 001.081 1.893v.108a24.167 24.167 0 002.7 3.407 21.9 21.9 0 004.272 3.407l479.359 287.4a21.638 21.638 0 0011.139 3.082zm-88.9 2.866l-401.22 240.569zm-404.2-773.518zm460.7 674.618L559.44 80.731zM438.047 79.65L43.529 737.126z","fill":"#fff"}})])
          )
        }
      }
    